export const PRODUCT_COUNT = 6;
export const CONTENT_PAGES_COUNT = 4;
export const RECENT_SEARCHES_COUNT = 4;
export const QUERY_SUGGESTIONS_COUNT = 5;

export const PRODUCTS_SOURCE_ID = "products_source";
export const CONTENT_PAGES_SOURCE_ID = "content_pages_source";
export const RECENT_SEARCHES_SOURCE_ID = "recent_searches_source";
export const QUERY_SUGGESTIONS_SOURCE_ID = "query_suggestions_source";

export const HIGHLIGHT_RESPONSE_REGEX =
    /__aa-highlight__(.*?)__\/aa-highlight__/g;
